import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { SnackbarType } from '@digilize/shared/definitions/src';
import { SnackbarService } from '@digilize/shared/feature/modules/snackbar/src';
import { copyToClipboard } from '@digilize/shared/utils/helpers/src';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'bwc-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss'],
})
export class ShareModalComponent {
  @Input() userId: string;
  @Output() closed = new EventEmitter<void>();

  get shareUrl(): string {
    return window.location.origin + '/shared-profile?uid=' + this.userId;
  }

  constructor(
    private translateService: TranslateService,
    private snackbarService: SnackbarService
  ) {}

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.close();
  }

  copyShareLink(): void {
    const shareUrl = window.location.origin + '/shared-profile?uid=' + this.userId;
    copyToClipboard(shareUrl);
    this.snackbarService.openSnackbar(SnackbarType.Success, {
      duration: 3000,
      data: { msg: 'global.share_link_copied', translate: true },
    });
  }

  openPreview(): void {
    window.open(this.shareUrl, '_blank');
  }

  close(): void {
    this.closed.emit();
  }

  onOverlayClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-overlay')) {
      this.close();
    }
  }
}
